// Events transverses du plan de marquage Welyft v1 : partagés par les parcours AE et Mutuelle Santé,
// d'où l'absence de préfixe de parcours dans leur nom.
export const CallbackTrackingEvents = {
    accessRequest: 'access_callback_request',
    requestValidated: 'request_callback',
} as const

// Le plan impose _valid/_invalid ; le parcours voyage émet encore voyage_phone_validation_true/false.
export const PhoneValidationTrackingEvents = {
    valid: 'health_form_phone_validation_valid',
    invalid: 'health_form_phone_validation_invalid',
} as const
